import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

export const OptionsList = ({
    onKeyDown,
    onSelectOption,
    optionIndex,
    options,
    optionsListVisible,
    name,
    renderOptions = (option) => <span>{option.label}</span>,
    optionsListCustom,
    loading,
    srDescription
}) => {
    const elementsRef = useRef([]);
    const optionsListCustomRef = useRef(null);

    useEffect(() => {
        elementsRef.current[optionIndex]?.focus();
        elementsRef.current[optionIndex]?.scrollIntoView({behavior: 'auto', block: 'nearest'});
        if(optionIndex === options.length && optionsListCustomRef.current) {
            optionsListCustomRef.current.focus();
        }
    }, [optionIndex, elementsRef, options.length]);

    return (
        <>
            {(options.length > 0 || optionsListCustom) &&
                <ul
                    aria-label={`Suggestions de saisie : ${srDescription}`}
                    role='listbox'
                    className={classNames('list-combobox', { show: optionsListVisible })}
                >
                    { options.map((option, index) => 
                        <li
                            aria-selected={optionIndex === index}
                            className='item'
                            id={`${name}-option-${index}`}
                            key={option.value}
                            onClick={() => onSelectOption(option)}
                            onKeyDown={onKeyDown}
                            role='option'
                            ref={(ref) => elementsRef.current[index] = ref}
                            tabIndex={-1}
                        >
                            {renderOptions(option)}
                        </li>
                    )}
                    { optionsListCustom &&
                        <li
                            className='item'
                            aria-selected={optionIndex === options.length}
                            role='option'
                            tabIndex={-1}
                            ref={optionsListCustomRef}
                            onKeyDown={onKeyDown}
                            onClick={() => {
                                optionsListCustom.handleClick();
                                onSelectOption({ label: optionsListCustom.label, value: optionsListCustom.label });
                            }}                >
                            <span className='link -highlight-icon'>{optionsListCustom.label}</span>
                        </li>
                    }
                </ul>
            }
            <div className="sr-only" aria-live='polite' aria-atomic='true'>
                {loading && <p>Chargement des résultats en cours</p>}
                {optionsListVisible && 
                    <>
                        {options.length <= 1 && <p> {options.length} résultat disponible.</p>}
                        {options.length > 1 && <p> {options.length} résultats disponibles.</p>}
                    </>
                }
            </div>
        </>
    )
}